import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import Nav from './Nav.js';
import PlayerBar from './PlayerBar.js';
import urls from '../../constants/urls.js';
import * as browserCheck from '../../utils/browserCheck.js';

class Header extends Component {

    componentDidMount() {
        //-- Header sizing on scroll
        if(browserCheck.canUseDom()) {
            $(window).on('scroll', function () {
                changeHeader();
            });
        }
          
        
      
        /*if(window.location.pathname == '/') {
            $('header.header').removeClass('header-sub');
        }
        else {
            $('header.header').addClass('header-sub');
        }*/

        //-- Change header on scroll
        changeHeader();

        function changeHeader() {
            if ($(window).scrollTop() > 60) {
                $('body').addClass('scrolled');
            }
            else {
                $('body').removeClass('scrolled');
            }            
        }          
    }

    isHomePage() {
        const { match, location, history } = this.props;
        return location.pathname == '/';       
    }

    render() {
        return (
            <header className={`header ${this.isHomePage() ? '' : 'header-sub'}`}>
                <Nav />
                <PlayerBar />
            </header>
        );
    }
}

Header.propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

export default withRouter(Header);